import { Plugins } from '@leverege/plugin';
import Symbolizer from '../../map/symbolizers/VehicleLocatorAlertsSymbolizer';
export default objectType => {
  return {
    id: `${objectType}.icon`,
    name: 'icon',
    displayName: 'Icon',
    valueType: 'icon',
    objectType,
    get: context => {
      const iconSubType = Symbolizer.symbolFor(null, {
        type: objectType,
        data: context
      });
      const iconFulltype = `${objectType}-${iconSubType || 'normal'}`;
      const iconUrl = Plugins.get('MapBoxSymbol', plg => plg.name === iconFulltype)?.[0]?.src;
      return iconUrl;
    }
  };
};